export default "__VITE_ASSET__C5LzOjE7__"